var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.themeStyles),attrs:{"id":"app"}},[(_vm.$store.state.isLogged)?_c('Navbar',{staticClass:"col-span-12 md:col-span-12 xl:col-span-12"}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }